export default "__VITE_ASSET__0a537376__"